export const trashIconSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17 10C17 10 16.5408 16.7165 16.2745 19.1244C16.1476 20.2745 15.4399 20.9484 14.2805 20.9697C12.0743 21.0095 11.8656 21.0121 9.66028 20.9654C8.54492 20.9425 7.84899 20.2601 7.72468 19.1304C7.45663 16.7012 7 10 7 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 6.5H5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18 6.5C17.277 6.5 16 6.5 15.3125 5.98806L15.0887 3.72533C14.9506 3.29655 14.4827 3 13.9494 3H10.0506C9.51734 3 9.04945 3.29655 8.91129 3.72533L8.68748 5.98806C8 6.5 6.72302 6.5 6 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const TrashIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 10C17 10 16.5408 16.7165 16.2745 19.1244C16.1476 20.2745 15.4399 20.9484 14.2805 20.9697C12.0743 21.0095 11.8656 21.0121 9.66028 20.9654C8.54492 20.9425 7.84899 20.2601 7.72468 19.1304C7.45663 16.7012 7 10 7 10"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M19 6.5H5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18 6.5C17.277 6.5 16 6.5 15.3125 5.98806L15.0887 3.72533C14.9506 3.29655 14.4827 3 13.9494 3H10.0506C9.51734 3 9.04945 3.29655 8.91129 3.72533L8.68748 5.98806C8 6.5 6.72302 6.5 6 6.5"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default TrashIcon
